import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './CarType.css'
import FormActions from '../../actions/FormActions'
import { formatFixedPrice } from '../../utils/format'
import classNames from 'classnames'

export class CarType extends Component {
  _radioButtonPressed (carType) {
    FormActions.selectCarType(carType.name)
  }

  _getImageForCarType (name) {
    switch (name) {
      case 'taxi':
        return 'icon-taxi-standard@3x'
      case 'storbil':
        return 'icon-taxi-large@3x'
      case 'business':
        return 'icon-taxi-premium@3x'
    }
  }

  _renderExtraInfo (carTypes) {    
    let extraInfo = '\u00A0'
    carTypes.forEach(function(carType) { 
      if (carType.checked && carType.extraInfo) extraInfo = 'Info: ' + carType.extraInfo
    })
    return extraInfo
  }

  _renderCarType (carType, i) {
    const { fixedPrice, taxiIsDisabled, premiumIsDisabled } = this.props
    const { name } = carType
    const labelStyles = classNames('labels', {
      estimate: fixedPrice && (carType.estimate || carType.estimateNotAvailable === true)
    })

    return (
      <li
        key={`CarType_${i}`}
        onClick={() => this._radioButtonPressed(carType)}
        styleName={classNames('radio-button', {
          active: carType.checked,
          disabled: (name === 'taxi' && taxiIsDisabled) || (name === 'business' && premiumIsDisabled)
        })}>
        <input
          checked={carType.checked}
          name="carType"
          onFocus={() => this._radioButtonPressed(carType)}
          readOnly
          type="radio" />
        <div styleName="indicator">
          <img src={`/static/img/cars/${this._getImageForCarType(name)}.png`} />
          <div styleName={labelStyles}>
            <label styleName="label">{carType.label}</label>
            <small styleName="labelSmall">{carType.labelSmall}</small>
            { fixedPrice && carType.estimate && <label styleName="label">{formatFixedPrice(carType.estimate)}</label> }
            { fixedPrice && carType.estimate && <small styleName="labelSmall"> Fast pris</small> }
            { fixedPrice && carType.estimateNotAvailable && <small styleName="labelSmall">Fast pris <strong>ej tillgängligt</strong></small> }
          </div>
        </div>
      </li>
    )
  }

  render () {
    const { carTypes, fixedPrice } = this.props
    const extraInfo = fixedPrice ? 'Info: Eventuell väntetidskostnad tillkommer på det fasta priset' : this._renderExtraInfo(carTypes)
    return (
      <div styleName="carType-container">
        <h2>Biltyp</h2>
        <ul styleName="radiobuttons">
          {carTypes.map((carType, i) => this._renderCarType(carType, i))}
        </ul>
        <p dangerouslySetInnerHTML={{ __html: extraInfo }} styleName="carType-info"/>
      </div>
    )
  }
}

CarType.propTypes = {
  carTypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    labelSmall: PropTypes.string,
    extraInfo: PropTypes.string,
    checked: PropTypes.bool,
    estimate: PropTypes.shape({}),
    estimateNotAvailable: PropTypes.bool
  })),
  fixedPrice: PropTypes.bool,
  premiumIsDisabled: PropTypes.bool,
  taxiIsDisabled: PropTypes.bool
}

CarType.defaultProps = {
  carTypes: []
}

export default CSSModules(CarType, styles, { allowMultiple: true })



// WEBPACK FOOTER //
// ./src/components/CarType/CarType.js